import React, { createRef, useState } from "react";
import { LazyLoadedGoogleModelViewer } from "@wss/model-viewer";
import { Spinner } from "@clarkinc/zest-design-system/ui";
import { ModelFiles } from "~/common/MediaViewerV2/model";
import OnClick from "../../3DViewer/OnClick";
import Toggle from "../../3DViewer/Toggle";
import { TransformComponent } from "react-zoom-pan-pinch";
interface ModelMediaRendererProps {
  model: ModelFiles;
  productDimensionsIsEnabled?: boolean;
}
const ModelMediaRenderer = ({
  model,
  productDimensionsIsEnabled
}: ModelMediaRendererProps) => {
  const [pressed, setPressed] = useState<boolean>(false);
  const parentRef = createRef<HTMLDivElement>();
  const onClick = () => OnClick({
    pressed,
    setPressed,
    productDimensionsIsEnabled,
    parentRef
  });
  return <TransformComponent wrapperStyle={{
    overflow: "visible",
    width: "auto",
    height: "100%"
  }} contentStyle={{
    width: "auto",
    height: "100%",
    maxHeight: "100vh"
  }} data-sentry-element="TransformComponent" data-sentry-component="ModelMediaRenderer" data-sentry-source-file="ModelMediaRenderer.tsx">
      <div className="hidden h-full relative w-full xl:block" style={{
      background: model.hasBackground ? "#A4A4A4" : ""
    }} ref={parentRef}>
        <LazyLoadedGoogleModelViewer data-sentry-element="LazyLoadedGoogleModelViewer" data-sentry-source-file="ModelMediaRenderer.tsx">
          <LazyLoadedGoogleModelViewer.ModelViewer src={model.relativeGlbFilePath} ios-src={model.relativeUsdzFilePath} className="h-full absolute w-full box-border focus:border-solid focus:border-blue-650 rounded-md" onLoad={onClick} data-sentry-element="unknown" data-sentry-source-file="ModelMediaRenderer.tsx">
            {productDimensionsIsEnabled && <>
                <LazyLoadedGoogleModelViewer.ProgressBar />
                <LazyLoadedGoogleModelViewer.Poster />
              </>}
          </LazyLoadedGoogleModelViewer.ModelViewer>
          {productDimensionsIsEnabled && <>
              <LazyLoadedGoogleModelViewer.Loading>
                <div className="absolute top-1/2 -translate-x-1/2 left-1/2 -translate-y-1/2">
                  <Spinner size="xlarge" theme="wss" />
                </div>
                <div className="bottom-4 inline-flex left-1/2 -translate-x-1/2 px-3 py-2 absolute bg-white border border-gray-200 border-solid items-center justify-center rounded gap-1">
                  <div className="w-32 h-2 bg-gray-200 rounded-3xl animate-pulse" />
                  <div className="w-8 h-5 bg-gray-200 rounded-3xl flex items-center justify-end animate-pulse">
                    <div className="w-4 h-4 bg-gray-50 rounded-full mr-0.5" />
                  </div>
                </div>
              </LazyLoadedGoogleModelViewer.Loading>
              <LazyLoadedGoogleModelViewer.Loaded>
                <div className="bottom-4 inline-flex left-1/2 -translate-x-1/2 px-3 py-2 absolute bg-white border border-gray-200 border-solid items-center rounded justify-center">
                  <label htmlFor="dimensionToggle" className="xs:text-sm text-base font-bold mb-0 whitespace-nowrap">
                    Product Dimensions
                  </label>
                  <div className="w-auto flex-auto ml-[12px]">
                    <Toggle disabled={false} onToggle={onClick} pressed={pressed} />
                  </div>
                </div>
              </LazyLoadedGoogleModelViewer.Loaded>
            </>}
        </LazyLoadedGoogleModelViewer>
      </div>
    </TransformComponent>;
};
export default ModelMediaRenderer;